import { render, staticRenderFns } from "./grccms_counter.vue?vue&type=template&id=2648f25e&scoped=true&"
import script from "./grccms_counter.vue?vue&type=script&lang=js&"
export * from "./grccms_counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648f25e",
  null
  
)

export default component.exports